export default __webpack_public_path__ + "static/media/sweepstakes.a2d43662.svg";